import { Pipe, PipeTransform } from "@angular/core";
@Pipe({ name: 'cpfcnpj' })
export class CpfCnpjPipe implements PipeTransform {
    transform(val, args) {
        let newStr = val;

        const mascaraCpf = (valor) => {
            return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
        }
        const mascaraCnpj = (valor) => {
            return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3\/\$4\-\$5");
        }

        if (val != null) {
            if (val.length <= 11) {
                newStr = mascaraCpf(val);
            } else {
                newStr = mascaraCnpj(val);
            }
        }

        return newStr;
    }
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/shared/pipes/cpfCnpj.pipe.ts